export const environment = {
  production: true,
  apiBase: 'https://test.cisassist.com.au/cis/api/form/',
  apiForm: 'https://test.cisassist.com.au/cis/api/tempAccom',
  googleMaps: {
    apiKey: '',
    libraries: ['places'],
  },
};
